module.exports = __webpack_public_path__ + "static_wap_online/img/gaikuojian_banner-app@2x.4346def3.png";